export const CLASS_SM_HIDDEN = 'sm-hide';
export const CLASS_SM_ONLY = 'sm-only';
